import styled from 'styled-components';

export const Container = styled.div`
  > h3 {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 16px;
  }
`;
